import { render, staticRenderFns } from "./AppContentSkeleton.vue?vue&type=template&id=5908e17d&scoped=true&"
import script from "./AppContentSkeleton.vue?vue&type=script&lang=js&"
export * from "./AppContentSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AppContentSkeleton.vue?vue&type=style&index=0&id=5908e17d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908e17d",
  null
  
)

export default component.exports